export default {
  title: '标题',
  firstOnlineTime: '创建时间',
  fromWebNum: '从WEB端帮助中心的打开次数',
  fromMicroNum: '从小程序帮助中心的打开次数',
  fileName: '文件名称',
  downloadNum: '从帮助中心的下载次数',
  readNum: '从帮助中心在线阅读的次数',
  uploadTime: '上传时间',
  searchPlaceholder: '搜索文件名称'
}
